import styled from "styled-components"
import { Grid, ButtonGroup } from "@material-ui/core"

export const StyledMainWrapper = styled(Grid)`
  .cls-svp-cell-wrapper-ui {
    display: flex;
    flex-direction: row;
  }

  .cls-svp-cell-row-wrapper-ui {
    border: 1px solid #c7acc9;
    padding: 5px;
    box-sizing: border-box;
    margin-bottom: 4px;
    border-radius: 10px;
    &:last-child {
      margin-bottom: 0px;
    }
  }

  .cls-svp-cell-item-ui {
    padding: 5px;
    min-width: 100px;
    min-height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #e5d8e6;
    border-radius: 8px;
    margin-right: 4px;
    box-sizing: border-box;
  }
  .cls-svp-cell-item-label-ui {
    text-align: left;
    width: 100%;
  }
  .cls-svp-cell-product-wrapper-ui {
    display: flex;
    flex-direction: row;
    width: 100%;
  }
  .cls-svp-cell-product-item-ui {
    position: relative;
    box-sizing: border-box;
    padding: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    max-width: 980px;
    border-radius: 6px;
    min-height: 200px;
    margin-right: 4px;
    margin-top: 4px;
    border: 1px dashed #a62992;
    overflow: hidden;

    &:last-child {
      margin-right: 0px;
    }
    .cls-svp-cell-product-img-wrapper-item-ui {
      padding: 5px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      background: #fff;
      max-width: 120px;
      max-height: 120px;
      border-radius: 6px;
      max-height: 200px;
      width: 100%;
      height: 100px;
      min-width: 40px;
      min-height: 40px;
      box-sizing: border-box;
      overflow: hidden;
      padding: 5px;
      box-sizing: border-box;
      img {
        width: 100%;
        height: auto;
        max-height: 120px;
      }
    }
    .cls-svp-cell-product-title-item-ui {
      margin-left: 4px;
    }
    .cls-svp-cell-title-item-u {
      margin-left: 4px;
    }
    .cls-svp-cell-product-title-kit-item-ui {
      display: -webkit-box;
      -webkit-line-clamp: 2; /* Limit to 2 lines */
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis; /* Add ellipsis */
      width: 100%;
      padding-left: 4px;
      font-size: 12px;
    }
    .cls-svp-cell-product-barcode-kit-item-ui {
      width: 100%;
      padding-left: 4px;
      font-size: 12px;
      word-wrap: break-word;
      border-radius: 40px;
    }
    .cls-svp-cell-product-pos-kit-item-ui {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
  }

  .cls-svp-cell-product-gram-kit-item-ui {
    margin: auto;
    position: absolute;
    right: -16px;
    bottom: 0px;
    height: fit-content;
    top: 0px;
    .cls-svp-cell-rotate-label {
      transform: rotate(270deg);
      background: pink;
      padding: 4px;
    }
  }

  .cls-svp-cell-product-pos-item-ui {
    padding: 3px;
    margin-right: 3px;
    border-radius: 10px;
  }

  .cls-svp-cell-empty-wrapper-ui {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100px;
  }
`
